import { render } from "./file_storage.vue?vue&type=template&id=0f42d0aa"
import script from "./file_storage.vue?vue&type=script&lang=js"
export * from "./file_storage.vue?vue&type=script&lang=js"

import "./file_storage.vue?vue&type=style&index=0&id=0f42d0aa&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__